import styled from 'styled-components';

const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-gap: 0 15px;
`;

export { FieldsContainer };
